import { forwardRef, type Ref, type SVGProps } from "react";
const IconSmartphoneFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M23 1H9a2 2 0 0 0-2 2v26a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2m-8 2h2a1 1 0 0 1 0 2h-2a1 1 0 0 1 0-2m-3 0a1 1 0 1 1-1 1 1 1 0 0 1 1-1m3 25a1 1 0 1 1 1 1 1 1 0 0 1-1-1m8-3H9V7h14z"
    />
  </svg>
);
const ForwardRef = forwardRef(IconSmartphoneFilledSVG);
ForwardRef.displayName = "IconSmartphoneFilled";
export { ForwardRef as IconSmartphoneFilled };
